import { FeatureFlagUseCase } from '@ibk/shared-types';
import { logTermsAcceptance, TERMS_SESSION_UI_ACK_STORAGE_KEY, } from '@ibk/shared-utils';
export function closeGateAndSetReady(setters) {
    setters.setModalOpen(false);
    setters.setPendingTerms(null);
    setters.setGateReady(true);
}
export function buildPendingSnapshotFromTermsStatus(result) {
    if (result.accepted) {
        return undefined;
    }
    const { term, termsHtml } = result;
    const hasContent = term != null || (termsHtml != null && termsHtml.trim().length > 0);
    if (!hasContent) {
        return undefined;
    }
    return {
        ...(term != null ? { term } : {}),
        ...(termsHtml != null && termsHtml.trim().length > 0 ? { termsHtml } : {}),
    };
}
export function readSessionUiAck() {
    if (typeof sessionStorage === 'undefined') {
        return false;
    }
    try {
        return sessionStorage.getItem(TERMS_SESSION_UI_ACK_STORAGE_KEY) === 'true';
    }
    catch {
        return false;
    }
}
export function persistSessionUiAck() {
    try {
        sessionStorage.setItem(TERMS_SESSION_UI_ACK_STORAGE_KEY, 'true');
    }
    catch (cause) {
        logTermsAcceptance('gate.session_ack_write_failed', { description: 'Não foi possível gravar o ack de termos em sessionStorage.' }, 'warn', cause);
    }
}
export function dailyCacheMatchesUserAndDay(dailyCache, today, userId) {
    if (dailyCache.day !== today) {
        return false;
    }
    const cachedUserId = dailyCache.userId;
    if (userId != null && userId !== '') {
        return cachedUserId === userId;
    }
    return cachedUserId == null || cachedUserId === '';
}
export function hasRestorablePendingSnapshot(snapshot) {
    if (!snapshot) {
        return false;
    }
    if (snapshot.term != null) {
        return true;
    }
    return (snapshot.termsHtml?.trim().length ?? 0) > 0;
}
export function buildPendingTermsState(term, termsHtml) {
    return {
        presentation: {
            title: term?.termName,
            documentUrl: term?.sourceType === 'LINK' && term.sourceValue.trim().length > 0 ? term.sourceValue : undefined,
            html: termsHtml,
        },
        term,
    };
}
export function createEffectCommitScope() {
    let active = true;
    return {
        ifActive(fn) {
            if (active) {
                fn();
            }
        },
        dispose() {
            active = false;
        },
    };
}
export async function resolvePlatformTermsAcceptanceFeatureEnabled(getFeatureFlags, isFeatureFlagWhiteListed, userId) {
    const flagsData = await getFeatureFlags();
    const appEnabled = isFeatureFlagWhiteListed(FeatureFlagUseCase.PLATFORM_APP_TERMACCEPTANCE_EXISTING_USER, userId, flagsData);
    const webEnabled = isFeatureFlagWhiteListed(FeatureFlagUseCase.PLATFORM_WEB_TERMACCEPTANCE_EXISTING_USER, userId, flagsData);
    return appEnabled || webEnabled;
}
